import { InternSet } from "internmap";
export default function union() {
  const set = new InternSet();
  for (var _len = arguments.length, others = new Array(_len), _key = 0; _key < _len; _key++) {
    others[_key] = arguments[_key];
  }
  for (const other of others) {
    for (const o of other) {
      set.add(o);
    }
  }
  return set;
}